import { render, staticRenderFns } from "./levelOfStudies.vue?vue&type=template&id=741b08fa&scoped=true"
import script from "./levelOfStudies.vue?vue&type=script&lang=js"
export * from "./levelOfStudies.vue?vue&type=script&lang=js"
import style0 from "./levelOfStudies.vue?vue&type=style&index=0&id=741b08fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741b08fa",
  null
  
)

export default component.exports